module.exports = __webpack_public_path__ + "static/media/shikhar.d476faef.jpg";